import { cn } from '../../lib/utils'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'accent' | 'outline' | 'success'
}

export function Badge({ className, variant = 'default', children, ...props }: BadgeProps) {
  const variants = {
    default: 'bg-surface-elevated text-text-secondary border-border-subtle',
    accent: 'bg-accent/10 text-accent-light border-accent/30',
    outline: 'bg-transparent text-text-secondary border-border-subtle',
    success: 'bg-success/10 text-success border-success/30',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium uppercase tracking-wider',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}
